module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "parent"
  }, [_c('article', {
    staticClass: "container"
  }, [_c('header', [_c('h1', [_vm._v(_vm._s(_vm.msg))])]), _vm._v(" "), _c('p', [_vm._v("I've been playing with your software and I think I've found my happy spot. I might love data visualization more than my children. I'm kidding, of course. The best thing in the world is gathering data on your children and then showing them how often they forget to feed the dog. Graphs are the new parenting tactic.")]), _vm._v(" "), _c('p', [_vm._v("I'm using vue for my portfolio and got the tableu api set up but I have an error that google was very unhelpful with. ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("I believe it's something about the canvas / object and way vue renders. I'll revisit this shortly because I'm now determined to figure it out. Also, in the spirit of \"done and not perfect\" and \"agile\" and \"transparency\" and \"fail fast\" and \"All The Chilches,\" here's a downloaded image of the data I played with and a link to the public worksheet. I plan on doing much, much more with this.")]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('code', [_vm._v("\"Viz resize limit hit. The calculated iframe size did not stabilize after 10 resizes.\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://public.tableau.com/views/Technologies_0/Sheet1?:embed=y&:display_count=yes&publish=yes"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/base/tableauTech.png",
      "alt": "DATA Visualization is The Most Fun"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b99a07ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/partials/tableau/Tableau.vue
// module id = 93
// module chunks = 0